export const total = ({ source, condition }) => {
    let filteredData = source

    if (condition)
        filteredData = source.filter((data) => condition.every((c) => data[c.type] === c.value))

    return filteredData.length.toLocaleString("en-IN")
}
export const formatDashboardHeaderKey = (value = "") =>
    value.replace(/[_-]+/g, " ").replace(/\b[a-z]/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
